module.exports = __webpack_public_path__ + "img/symbol_2.7c5b7b35.png";